import { FC } from 'react';
import AccordionBtn from 'components/commercetools-ui/atoms/accordion';
import dynamic from 'next/dynamic';
const Markdown = dynamic(() => import('../../../organisms/markdown'));
import Breadcrumb from 'components/commercetools-ui/atoms/breadcrumb';
 import Link from 'components/commercetools-ui/atoms/link';
 import { ChevronRightIcon, HomeIcon } from '@heroicons/react/24/outline';
 import usePath from 'helpers/hooks/usePath';


export type PrivacyProps = {
  data?: any;
};
const PrivacyPage: FC<PrivacyProps> = ({ data }) => {
  const PrivacyData = data?.sections?.[0]?.section_with_heading_description || '';
  const { pathWithoutQuery } = usePath();

  return (
    <div className=" w-full">
       <div className="hidden px-24 pb-8 pt-16 md:block md:px-12 lg:px-32 xl:px-44 2xl:px-64">
         <Breadcrumb Separator={<ChevronRightIcon className="mt-2 w-16" />} listClassName="!gap-x-16">
           <Link link={'/'}>
             <HomeIcon className="mt-6 w-20" />
           </Link>
           <span className="text-14 font-normal leading-4 text-[#666]">{pathWithoutQuery.includes('/privacy/') ? 'Privacy Policy' : 'Terms & Conditions'}</span>
         </Breadcrumb>
       </div>
        <div className="px-24 lg:px-150 2xl:px-280">
          <div className="">
            <div className="text-32 font-medium leading-10 text-primary-black lg:border-none py-32 xl:text-36 2xl:py-48 2xl:text-48 2xl:leading-[3.5rem]">
              {PrivacyData.title}
            </div>

           <Markdown
  className="
    text-primary-black
    text-14 md:text-16 2xl:text-18

    [&_p]:my-10

    /* ORDERED LIST */
    [&_ol]:list-decimal
    [&_ol]:ml-20
    [&_ol>li]:my-10

    /* UNORDERED LIST */
    [&_ul]:list-disc
    [&_ul]:ml-20
    [&_ul>li]:my-10

    /* LINK COLOR FIX */
    [&_a]:text-primary-black
    hover:[&_a]:underline
  "
  markdown={PrivacyData.description}
/>
          </div>
        </div>
      </div>
  );
};
export default PrivacyPage;
